// @ts-nocheck
import React, { useMemo, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { isFlagOn } from "../../utils/methods/booleanFlag";
import { ExpandMore } from "@mui/icons-material";
import { Box } from "@mui/system";
import { CustomDatePicker } from "../Custom/DatePicker";
import { CustomInput } from "../Custom/Input";
import { AddPhotoAlternate } from "@mui/icons-material";
import ReusableParentContainer from "../Custom/ReusableParentContainer";
import ImageCropper from "../user/ImageCroppper";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { useFormik } from "formik";
import theme from "../../theme";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import {
  acceptReimbursementAction,
  claimReimbursementAction,
  deleteReimbursementCategory,
  fetchReimbursementCategory,
  rejectReimbursementAction,
} from "../../store/actions/eventRequestDetails";
import { Close } from "@mui/icons-material";
import { alertDialogAciton } from "../../store/actions/auth";
import { ReasonModal } from "../../pages/contractor-side/ScheduleTab/tabs/PositionManagementTab";
import {
  fetchContractorLogsAction,
  fetchSinglePositionDataAction,
  updateScheduleDataAction,
} from "../../store/actions/contractorScheduleTabActions";
import { useSelector } from "react-redux";
import { addLogAction } from "../../store/actions/logs";
import { Delete } from "@mui/icons-material";
import { isUserRole, isActiveRole } from "../../utils/methods/storeFunc";
import ExpenseReceiptManager from "./ExpenseReceiptManager";
import { RECEIPT_MAX_BYTES } from "../../api/expenseReceipts";
import { USER_ROLES } from "../../staticData/userRoles";
import {
  addReimbursementByAdminAction,
  addReimbursementByContractorAction,
  getAllAdjustmentOfEventAction,
  getReimbursementCategoriesAction,
  removeReimbursementAndDeductionCategoriesAction,
  removeReimbursementOrDeductionAction,
  updateReimbursementAction,
} from "../../store/actions/event/adjustments";
import { CustomIconButton } from "../Custom/CustomIconButton";
import {
  ADJUSTMENT_TYPES,
  getUniversalDateTimeFormat,
  REIMBURSEMNET_STATUS,
} from "../../appCalcutions";
import InfoHover from "../Tooltip/InfoHover";
import ReimbursementEditor from "./ReimbursementEditor";

export default function ReimbursementAcc({
  user,
  data,
  expanded,
  handleAccChange,
  eventId,
  setData,
  isEditable,
  status,
  index,
  fetchPO = () => {},
}) {
  const [cropModal, setCropModal] = React.useState(false);
  const [tempImage, setTempImage] = React.useState(null);
  const imageRef = React.useRef(null);
  const receiptObjectUrls = React.useRef(new Set());
  const receiptUrl = (file) => { const url = URL.createObjectURL(file); receiptObjectUrls.current.add(url); return url; };
  React.useEffect(() => () => { receiptObjectUrls.current.forEach(url => URL.revokeObjectURL(url)); receiptObjectUrls.current.clear(); }, []);
  const [reason, setReason] = React.useState("");
  const [reasonModal, setReasonModal] = React.useState(false);
  const [viewProfileImageFullscreen, setViewProfileImageFullscreen] =
    React.useState({
      status: false,
      image: null,
    });
  const [imageList, setImageList] = React.useState([]);
  const hasSavedReimbursement = !data?.newValues && /^[a-f0-9]{24}$/i.test(String(data?._id ?? ""));
  const [approveDialog, setApproveDialog] = React.useState(false);
  const [approved, setApproved] = React.useState(0.0);
  const [approvError, setApprovError] = React.useState({
    status: false,
    touched: false,
    message: "",
  });
  const { userId, userRole, userName } = useSelector((state) => state.auth);
  const { reimbursementCategories, eaLoading, arLoading } = useSelector(
    (state) => state?.adjustmentsReducer,
  );

  const isBothPosAndConPresent = useMemo(() => {
    return data?.positionDetails?._id && data?.contractorDetails?._id;
  }, [data]);

  const dispatch = useDispatch();

  function refreshList() {
    dispatch(
      getAllAdjustmentOfEventAction({
        payload: { params: { eventId } },
        successCallback: () => {
          setApproved(0.0);
        },
      }),
    );
    dispatch(getReimbursementCategoriesAction({}));
    if (fetchPO) {
      fetchPO();
    }
  }

  const initialValues = {
    reImbursementType: "",
    expanseDate:
      data?.positionDetails?.startDate ||
      data?.positionDetails?.positionDate ||
      data?.positionDetails?.positionStartDate
        ? data?.positionDetails?.startDate ||
          data?.positionDetails?.positionDate ||
          data?.positionDetails?.positionStartDate
        : null,
    reImbursementAmount: 0.0,
    explanation: "",
    gearDescription: "",
    // Opt-in, never opt-out: a reimbursement is re-billed to the client only
    // when an admin explicitly ticks the box. Most reimbursements belong to the
    // crew member and must NOT reach the client invoice.
    reImburseAddInClientInvoice: false,
    reImburseAddInPO: true,
    isLinkToContractor: isBothPosAndConPresent ? true : null,
    categoryType: "",
    notes: "",
    files: [],
  };

  const validationSchema = Yup.object().shape({
    reImbursementType:
      user == "admin" && data?.reImbursementStatus?.toLowerCase() == "draft"
        ? Yup.string()
        : Yup.string().required("Type of Reimbursement is required"),
    gearDescription: Yup.string()
      .trim()
      .when("reImbursementType", {
        is: (val) => val === "Equipment",
        then: () => Yup.string().required("Description of Gear is required"),
        otherwise: () => Yup.string().optional(),
      }),
    explanation:
      user == "admin" && data?.reImbursementStatus?.toLowerCase() == "draft"
        ? Yup.string()
        : Yup.string()
            .trim()
            .when("reImbursementType", {
              is: (val) => val === "Other",
              then: () => Yup.string().required("Explanation is required"),
              otherwise: () => Yup.string().optional(),
            }),
    expanseDate: Yup.date().required("Date of Expense is required"),
    reImbursementAmount:
      user == "admin" && data?.reImbursementStatus?.toLowerCase() == "draft"
        ? Yup.number().nullable()
        : Yup.number()
            .required("Amount is required")
            .test(
              "minAmount",
              "Amount should be greater than 0",
              (value) => value > 0,
            ),
    reImburseAddInClientInvoice: Yup.boolean(),
    categoryType:
      user == "admin" && data?.reImbursementStatus?.toLowerCase() == "draft"
        ? Yup.string().required("Category is required")
        : Yup.string(),
    notes: Yup.string()
      .trim()
      .max(150, "Notes must be less than 150 characters")
      .nullable(true)
      .transform((value, originalValue) =>
        originalValue.trim() === "" ? null : value,
      ),
    isLinkToContractor:
      user == "admin" &&
      data?.reImbursementStatus?.toLowerCase() == "draft" &&
      isBothPosAndConPresent
        ? Yup.boolean().nonNullable(
            "Please select where the reimbursement should linked to",
          )
        : Yup.boolean().nullable(),
    files: Yup.array().when("reImbursementType", {
      is: (val) => val === "Parking",
      then: () => Yup.array().min(1, "Atleast one image is required"),
      otherwise: () => Yup.array().optional(),
    }),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      if (user == "admin" && approved == 0) {
        setApprovError({
          touched: true,
          message: "Approved amount should be greater than 0",
          status: true,
        });
        return;
      }

      const formData = new FormData();
      for (const key in values) {
        if (key === "reImburseAddInPO" && user !== "admin") continue;
        if (key === "files") {
          values[key]?.forEach((file) => {
            formData.append(`files`, file);
          });
          continue;
        }
        if (key == "reImbursementType" && values[key] == "") {
          formData.append("reImbursementType", "Other");
          continue;
        }
        if (key === "reImbursementAmount") {
          formData.append("claimAmount", values[key] || approved);
          continue;
        }

        if (key == "categoryType")
          [formData.append("reImbursementCategoryType", values[key])];
        formData.append(key, values[key]);
      }
      formData.append("type", ADJUSTMENT_TYPES.REIMBURSEMENT);
      if (data?.positionDetails?._id) {
        formData.append("positionId", data?.positionDetails?._id);
      }
      if (!isActiveRole(USER_ROLES.CONTRACTOR)) {
        formData.append("reImbursementStatus", REIMBURSEMNET_STATUS.ACCEPTED);
        formData.append("approvedAmount", approved);
      } else {
        formData.append("reImbursementStatus", REIMBURSEMNET_STATUS.PENDING);
      }

      const params = {
        eventId,
        contractorId: data?.contractorDetails?._id,
      };

      // in case of admin link it to contractor while position is selected
      // if (isBothPosAndConPresent && data?.reImbursementStatus == "draft") {
      //   if (values?.isLinkToContractor) {
      //     formData?.delete("positionId");
      //   }
      // }

      // if it's a contractor always link it to the contractor
      // if (user == "contractor") {
      //   formData?.delete("positionId");
      // }

      formData.append(
        "isReimbursementAttachedToPosition",
        !values?.isLinkToContractor,
      );

      // NOTE: do the api call to push it
      // better way to do is create a dispatch action and call it here.
      const details = {
        eventId: data?.eventId,
        positionName: data?.positionDetails?.name,
      };
      if (!isActiveRole(USER_ROLES.CONTRACTOR)) {
        dispatch(
          addReimbursementByAdminAction({
            payload: {
              formData,
              params,
            },
            successCallback: (msg) => {
              refreshList();
              dispatch(
                addLogAction({
                  id: details?.eventId,
                  payload: {
                    actionById: userId,
                    description: `Admin ${userName} created a reimbursement of $${approved} for ${isBothPosAndConPresent ? (values?.isLinkToContractor ? data?.contractorDetails?.name : data?.positionDetails?.name) : (data?.contractorDetails?.name ?? data?.positionDetails?.name)}.`,
                  },
                  successCallback: () => {
                    dispatch(
                      fetchContractorLogsAction({
                        payload: {
                          eventId: details?.eventId,
                        },
                      }),
                    );
                  },
                }),
              );
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Success",
                  message:
                    msg ||
                    "Reimbursement request has been submitted successfully",
                }),
              );
            },
            failureCallback: (msg) => {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Error",
                  message: msg || "Failed to add reimbursement request",
                }),
              );
            },
          }),
        );
      } else {
        dispatch(
          addReimbursementByContractorAction({
            payload: {
              formData,
              params: {
                eventId,
                contractorId: data?.contractorDetails?._id,
              },
            },
            successCallback: (msg) => {
              dispatch(
                fetchSinglePositionDataAction({
                  sessionId: data?.sessionId,
                  id: data?.positionDetails?._id,
                }),
              );
              dispatch(
                addLogAction({
                  id: details?.eventId,
                  payload: {
                    actionById: userId,
                    description: `Contractor ${userName}, applied for reimbursement of $${values?.reImbursementAmount} for ${values?.reImbursementType} type on ${details?.positionName} position.`,
                  },
                  successCallback: () => {
                    dispatch(
                      fetchContractorLogsAction({
                        payload: {
                          eventId: details?.eventId,
                        },
                      }),
                    );
                  },
                }),
              );
              dispatch(updateScheduleDataAction({ ...data }));
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Success",
                  message:
                    msg ||
                    "Reimbursement request has been submitted successfully",
                }),
              );
            },
            failureCallback: (msg) => {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Error",
                  message: msg || "Failed to submit the reimbursement request",
                }),
              );
            },
          }),
        );
      }
    },
  });

  const { values, handleChange, touched, errors, handleBlur, submitForm } =
    formik;

  React.useEffect(() => {
    if (data?.newValues) {
      formik.resetForm();
      setApproved(0.0);
      setImageList([]);
      return;
    }
    if (data?.reImbursementType) {
      formik.setFieldValue("reImbursementType", data?.reImbursementType || "");
      formik.setFieldValue("expanseDate", data?.expanseDate || null);
      formik.setFieldValue("reImbursementAmount", data?.claimAmount || 0);
      formik.setFieldValue("notes", data?.notes || "");
      formik.setFieldValue("files", data?.parkingImage || []);
      formik.setFieldValue("gearDescription", data?.gearDescription || "");
      formik.setFieldValue("explanation", data?.explanation || "");
      formik.setFieldValue(
        "reImburseAddInClientInvoice",
        isFlagOn(data?.reImburseAddInClientInvoice),
      );
      formik.setFieldValue(
        "categoryType",
        data?.reImbursementCategoryType || data?.reImbursementType || "",
      );
      formik.setFieldValue("reImburseAddInPO", data?.reImburseAddInPO === undefined ? true : isFlagOn(data.reImburseAddInPO));
      setImageList(data?.files || []);
      setApproved(
        data?.reImbursementStatus?.toLowerCase() == "pending"
          ? data?.approvedAmount || data?.claimAmount || 0.0
          : data?.approvedAmount,
      );
    }
  }, [data]);

  React.useEffect(() => {
    if (approved <= 0 && approvError?.touched) {
      setApprovError({
        status: true,
        touched: true,
        message: "Approved amount should be greater than 0",
      });
    } else {
      setApprovError({
        status: false,
        touchec: true,
        message: "",
      });
    }
  }, [approved]);

  const isPdfReceipt = (file) => file?.type === "application/pdf" || (!file?.type && /\.pdf$/i.test(file?.name || ""));
  const addImageToList = (image) => {
    if (!image) {
      return;
    }
    const chosen = formik.values.files || [];
    if (isPdfReceipt(image) && chosen.some(isPdfReceipt)) {
      formik.setFieldTouched("files", true, false);
      formik.setFieldError("files", "Add one PDF when creating a reimbursement. Upload additional receipts after saving.");
      return;
    }
    if (chosen.length >= 5 || chosen.reduce((sum, file) => sum + (file?.size || 0), 0) + image.size > RECEIPT_MAX_BYTES) {
      formik.setFieldTouched("files", true, false);
      formik.setFieldError("files", "Select up to 5 receipt files, totaling 4 MB or less");
      return;
    }
    setImageList((imageList) => {
      return [
        ...imageList,
        {
          id: imageList?.length + 1,
          image: receiptUrl(image),
          blob: image,
          fileName: image.name || "Receipt",
        },
      ];
    });
    formik.setFieldValue("files", [...formik.values.files, image]);
  };
  const handleSubmitForm = () => {
    // formik.setTouched({
    //   reImbursementType: true,
    //   expanseDate: true,
    //   reImbursementAmount: true,
    //   notes: true,
    //   files: true,
    // });
    formik.validateForm().then(() => {
      formik.submitForm();
    });
  };

  const getColorOfStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "white";
      case "pending":
        return "#4D4D4D";
      case "accepted":
        return "#02493E";
      case "rejected":
        return "#371414";

      default:
        return "white";
    }
  };

  const getTextColorOfStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "black";
      case "pending":
        return "white";
      case "accepted":
        return "#07EEC5";
      case "rejected":
        return "#FF4B4B";

      default:
        return "black";
    }
  };

  const rid = data?._id;

  const handleAdminAccept = () => {
    if (user !== "admin") return;
    if (!approveDialog) {
      setApproveDialog(true);
      return;
    }

    const apiData = {
      reImbursementStatus: "Accepted",
      approvedAmount: approved,
      reImbursementCategoryType: values?.categoryType,
      reImburseAddInClientInvoice: values?.reImburseAddInClientInvoice,
    };

    const details = {
      eventId: data?.eventId,
      positionName: data?.positionDetails?.name,
    };
    dispatch(
      updateReimbursementAction({
        payload: {
          data: apiData,
          additionalData: {
            contractorId: data?.contractorDetails?._id,
          },
          params: {
            eventId,
            reimbursementDeductionId: rid,
          },
        },
        successCallback: () => {
          refreshList();
          dispatch(
            addLogAction({
              id: details?.eventId,
              payload: {
                actionById: userId,
                description: `${
                  userRole.charAt(0).toUpperCase() + userRole.slice(1)
                } ${userName}, accepted the reimbursement request of ${data?.contractorName} on ${data?.positionDetails?.name} position.`,
                positionId: data?.positionDetails?._id,
              },
            }),
          );
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Success",
              message: "Reimbursement request has been accepted",
            }),
          );
        },
        failureCallback: () => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message: "Failed to accept the reimbursement request",
            }),
          );
        },
      }),
    );
    setApproveDialog(false);
  };

  const handleAdminReject = () => {
    if (user !== "admin") return;
    const apiData = {
      reImbursementStatus: "Rejected",
      rejectReason: reason,
      reImbursementCategoryType: values?.categoryType || "",
    };
    dispatch(
      updateReimbursementAction({
        payload: {
          data: apiData,
          params: {
            eventId,
            reimbursementDeductionId: rid,
          },
        },
        successCallback: () => {
          refreshList();
          dispatch(
            addLogAction({
              id: data?.eventId,
              payload: {
                actionById: userId,
                description: `${
                  userRole.charAt(0).toUpperCase() + userRole.slice(1)
                } ${userName}, rejected the reimbursement request of ${data?.contractorName} on ${data?.positionDetails?.name} position.`,
                positionId: data?.positionDetails?._id,
              },
            }),
          );
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Success",
              message: "Reimbursement request has been rejected",
            }),
          );
        },
        failureCallback: () => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message: "Failed to reject the reimbursement request",
            }),
          );
        },
      }),
    );
  };

  const privateReceipts = hasSavedReimbursement && expanded === `panel${index}` &&
    isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN, USER_ROLES.COORDINATOR, USER_ROLES.CONTRACTOR)
    ? <Box sx={{ mt: 2, width: "100%" }}><ExpenseReceiptManager eventId={eventId} reimbursementId={String(data._id)} /></Box>
    : null;

  if (data?.sourceBillableChargeId) {
    return <Accordion expanded={expanded === `panel${index}`} onChange={handleAccChange(`panel${index}`)}
      sx={{ width: "100%", backgroundColor: "transparent", border: "1px solid #D175B6", borderRadius: 2 }}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography>{data.reImbursementCategoryType || "Expense reimbursement"} · ${Number(data.approvedAmount || 0).toFixed(2)} · Approved</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>{data.notes || "Approved technician reimbursement for this show."}</Typography>
        <Typography sx={{ mt: 1 }}>Included in the PO when generated or regenerated. This does not mean payment has been made.</Typography>
        {privateReceipts}
        {user === "admin" && <Typography sx={{ mt: 1 }}>Linked to a client charge. Manage the technician and reimbursement amount in Non Taxable Charges to keep both records consistent.</Typography>}
      </AccordionDetails>
    </Accordion>;
  }

  return (
    <>
      <Accordion
        sx={{
          borderRadius: "8px",
          backgroundColor: "transparent",
          width: "100%",
        }}
        expanded={expanded === `panel${index}`}
        onChange={handleAccChange(`panel${index}`)}
      >
        <AccordionSummary
          sx={{
            backgroundColor: "rgba(100, 100, 100, 0.4)",
            border: `1px solid ${getCssVariableHandler({
              variableName: "--primary-pink-hex",
            })}`,
            borderRadius: "8px",
            "& p": {
              fontSize: "1.2rem",
            },

            "@media(max-width: 600px)": {
              fontSize: "1rem",
            },
          }}
          expandIcon={<ExpandMore sx={{ color: "white" }} />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>
            {values?.categoryType || values?.reImbursementType || ""}
          </Typography>
          <Typography sx={{ color: "white", WebkitLineClamp: 1, width: "43%" }}>
            {values?.expanseDate
              ? dayjs(values?.expanseDate).format("ddd MM-DD-YYYY") ||
                "Date of Expense"
              : ""}
          </Typography>
          <Typography
            sx={{
              color: getTextColorOfStatus(status),
              border: `1px solid ${getColorOfStatus(status)}`,
              backgroundColor: getColorOfStatus(status),
              padding: "0.2rem",
              borderRadius: "8px",
              minWidth: "23%",
              textAlign: "center",
              height: "35px",
            }}
          >
            {status || "Draft"}
          </Typography>
          {/* NOTE: only show the delete button when the data is saved  */}
          {data?._id &&
            isUserRole(
              USER_ROLES.SUPERADMIN,
              USER_ROLES.ADMIN,
              USER_ROLES.COORDINATOR,
            ) && (
              <CustomIconButton
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  dispatch(
                    alertDialogAciton({
                      open: true,
                      title: "Warning",
                      message:
                        "Are you sure, you want to remove this reimbursement?",
                      okLabel: "Delete",
                      onOk: () => {
                        dispatch(
                          removeReimbursementOrDeductionAction({
                            payload: {
                              data: {
                                ids: [
                                  {
                                    id: data?._id,
                                  },
                                ],
                              },
                              additionalData: {
                                contractorId: data?.contractorDetails?._id,
                              },
                            },
                            successCallback: () => {
                              refreshList();
                            },
                          }),
                        );
                      },
                    }),
                  );
                }}
              >
                <Delete sx={{ fontSize: "1.5rem" }} />
              </CustomIconButton>
            )}
        </AccordionSummary>
        <AccordionDetails
          sx={{
            backgroundColor: "transparent",
            border: `1px solid ${getCssVariableHandler({
              variableName: "--primary-pink-hex",
            })}`,
            borderTop: "none",
            borderRadius: "8px",
            padding: "1rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "1rem",
            flexDirection: "column",
            overflowY: "auto",
            maxHeight: "65%",
            "& p": {
              fontSize: "1.2rem",
            },
            "@media(max-width: 600px)": {
              fontSize: "1rem",
            },
          }}
          className="custom-scroll-design"
        >
          {hasSavedReimbursement && user === "admin" && isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN) &&
            ["accepted", "pending"].includes(String(data?.reImbursementStatus).toLowerCase()) &&
            <ReimbursementEditor key={`${userId}:${userRole}:${eventId}:${data._id}`} eventId={eventId} entry={data} onSaved={(message) => { refreshList(); dispatch(alertDialogAciton({ open: true, title: "Success", message })); }} />}

          <Box
            sx={{
              padding: "1rem",
              width: "100%",
              display:
                data?.positionDetails?._id || data?.positionId
                  ? "block"
                  : "none",
            }}
          >
            {(data?.positionDetails?._id || data?.positionId) &&
            data?.reImbursementStatus == "draft" ? (
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                }}
              >
                Position: {data?.positionDetails?.name}
              </Typography>
            ) : null}
            {data?.positionId && data?.reImbursementStatus !== "draft" ? (
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                }}
              >
                Position: {data?.positionName}
                {data?.positionOrder ? `-${data?.positionOrder}` : ""} (
                {getUniversalDateTimeFormat({
                  dateTime: data?.positionStartDate,
                })}
                )
              </Typography>
            ) : null}
          </Box>
          <Box
            sx={{
              display:
                user == "admin" &&
                data?.reImbursementStatus?.toLowerCase() == "draft"
                  ? "none"
                  : "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "2rem",
              color: "white",
              paddingLeft: "1rem",
              width: "100%",
              "@media(max-width: 600px)": {
                flexDirection: "column",
                gap: "0.5rem",
              },
            }}
          >
            <InputLabel
              sx={{
                color: "white",
                fontWeight: "500",
                fontSize: "1rem",
              }}
              id="type-select"
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                Type*
              </Typography>
            </InputLabel>
            <Select
              labelId="type-select"
              readOnly={!isEditable}
              name="reImbursementType"
              value={values?.reImbursementType || ""}
              renderValue={(selected) => selected
                ? (String(selected).toLowerCase() === "reimbursement" ? "Reimbursement" : String(selected))
                : (hasSavedReimbursement ? "Not recorded" : "Select Type")}
              onChange={handleChange}
              onBlur={handleBlur}
              displayEmpty
              sx={{
                width: "200px",
                color: "white",
                "& .MuiSelect-icon": {
                  color: "white",
                },
                "& .MuiSelect-select": {
                  paddingY: "1rem",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })} !important`,
                },
                border: `1px solid ${getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                })}
                      `,
                borderRadius: "8px",
              }}
              placeholder="Select Type"
            >
              <MenuItem
                disabled
                sx={{
                  display: "none",
                }}
                value=""
              >
                Select Type
              </MenuItem>
              {/* Preserve historical values that are not one of the current input options. */}
              {values?.reImbursementType && !["Equipment", "Parking", "Other"].includes(values.reImbursementType) &&
                <MenuItem value={values.reImbursementType}>
                  {String(values.reImbursementType).toLowerCase() === "reimbursement" ? "Reimbursement" : String(values.reImbursementType)}
                </MenuItem>}
              <MenuItem value="Equipment">Equipment</MenuItem>
              <MenuItem value="Parking">Parking</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </Box>
          {errors?.reImbursementType && touched?.reImbursementType && (
            <Typography
              sx={{
                width: "100%",
                textAlign: "center",
              }}
              color="error"
            >
              {errors?.reImbursementType}
            </Typography>
          )}

          {/* NOTE: explanation of gear */}

          {values?.reImbursementType === "Equipment" && (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "0.5rem",
                  color: "white",
                  paddingLeft: "1rem",
                  width: "100%",
                  flexDirection: "column",
                }}
              >
                <InputLabel
                  sx={{
                    color: "white",
                    fontWeight: "500",
                    fontSize: "1rem",
                  }}
                  id="dec-gear-input"
                >
                  <Typography
                    sx={{
                      fontWeight: "500",
                      fontSize: "1rem",
                      color: "white",
                      "&:hover": {
                        cursor: "pointer",
                      },
                    }}
                  >
                    Description of Gear*
                  </Typography>
                </InputLabel>

                <CustomInput
                  labelId="dec-gear-input"
                  className="rate-input"
                  name="gearDescription"
                  sx={{
                    border: `1px solid ${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })} `,
                    borderRadius: "8px",
                    fontSize: "16px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: `${getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      })} !important`,
                    },
                  }}
                  type="text"
                  fullWidth
                  placeholder="Description of Gear"
                  onChange={handleChange}
                  readOnly={!isEditable}
                  onBlur={handleBlur}
                  value={values?.gearDescription}
                />
              </Box>
              {errors?.gearDescription && touched?.gearDescription && (
                <Typography
                  sx={{
                    width: "100%",
                    textAlign: "center",
                  }}
                  color="error"
                >
                  {errors?.gearDescription}
                </Typography>
              )}
            </>
          )}

          {/* NOTE: explanation */}

          {values?.reImbursementType === "Other" && (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "0.5rem",
                  color: "white",
                  paddingLeft: "1rem",
                  width: "100%",
                  flexDirection: "column",
                }}
              >
                <InputLabel
                  sx={{
                    color: "white",
                    fontWeight: "500",
                    fontSize: "1rem",
                  }}
                  id="explanation-input"
                >
                  <Typography
                    sx={{
                      fontWeight: "500",
                      fontSize: "1rem",
                      color: "white",
                      "&:hover": {
                        cursor: "pointer",
                      },
                    }}
                  >
                    Explanation*
                  </Typography>
                </InputLabel>
                <CustomInput
                  labelId="explanation-input"
                  className="rate-input"
                  name="explanation"
                  sx={{
                    border: `1px solid ${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })} `,
                    borderRadius: "8px",
                    fontSize: "16px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: `${getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      })} !important`,
                    },
                  }}
                  type="text"
                  fullWidth
                  placeholder="Explanation"
                  onChange={handleChange}
                  readOnly={!isEditable}
                  onBlur={handleBlur}
                  value={values?.explanation}
                />
              </Box>
              {errors?.explanation &&
                touched?.explanation &&
                data?.reImbursementStatus?.toLowerCase() == "draft" && (
                  <Typography
                    sx={{
                      width: "100%",
                      textAlign: "center",
                    }}
                    color="error"
                  >
                    {errors?.explanation}
                  </Typography>
                )}
            </>
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "2rem",
              color: "white",
              paddingLeft: "1rem",
              width: "100%",
              "@media(max-width: 600px)": {
                flexDirection: "column",
                gap: "0.5rem",
              },
            }}
          >
            <InputLabel
              sx={{
                color: "white",
                fontWeight: "500",
                fontSize: "1rem",
              }}
              id="date-select"
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                Date of Expense*
              </Typography>
            </InputLabel>
            <Box
              sx={{
                width: "200px",
              }}
            >
              <CustomDatePicker
                variant="rounded"
                name="expanseDate"
                sx={{
                  "& fieldset": {
                    borderColor: `${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })} !important`,
                    borderWidth: "1.8px",
                  },
                  "& input": {
                    paddingY: "1rem !important",
                  },
                }}
                labelId="date-select"
                value={values?.expanseDate ? dayjs(values.expanseDate) : null}
                // format={values?.expanseDate ? "ddd MM/DD/YYYY" : "MM/DD/YYYY"}
                onBlur={handleBlur}
                readOnly={!isEditable}
                onChange={(date) => {
                  formik.setFieldValue(
                    "expanseDate",
                    date?.format("YYYY-MM-DD"),
                  );
                }}
              />
            </Box>
          </Box>
          {errors?.expanseDate && touched?.expanseDate && (
            <Typography
              sx={{
                width: "100%",
                textAlign: "center",
              }}
              color="error"
            >
              {errors?.expanseDate}
            </Typography>
          )}

          <Box
            sx={{
              display:
                user == "admin" &&
                data?.reImbursementStatus?.toLowerCase() == "draft"
                  ? "none"
                  : "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "2rem",
              color: "white",
              paddingLeft: "1rem",
              width: "100%",
              "@media(max-width: 600px)": {
                flexDirection: "column",
                gap: "0.5rem",
              },
            }}
          >
            <InputLabel
              sx={{
                color: "white",
                fontWeight: "500",
                fontSize: "1rem",
              }}
              id="amount-input"
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                {/* Amount* */}
                {(data?.reImbursementStatus === "Accepted" &&
                  user === "contractor") ||
                (data?.reImbursementStatus === "Pending" && user === "admin") ||
                (data?.reImbursementStatus === "Accepted" && user === "admin")
                  ? "Claimed Amount*"
                  : "Amount*"}
              </Typography>
            </InputLabel>

            <Box
              sx={{
                position: "relative",
              }}
            >
              <CustomInput
                labelId="amount-input"
                className="rate-input"
                name="reImbursementAmount"
                sx={{
                  border: `1px solid ${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })} `,
                  borderRadius: "8px",
                  fontSize: "16px",
                  width: "200px !important",
                  // "& fieldset": {
                  //   border: "none",
                  // },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: `${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })} !important`,
                  },
                }}
                type="number"
                fullWidth
                placeholder="00.00"
                onChange={handleChange}
                readOnly={!isEditable}
                onBlur={handleBlur}
                value={values?.reImbursementAmount}
                startAdornment={
                  <InputAdornment position="start">
                    <Typography variant="h5" color="primary">
                      &#36;
                    </Typography>
                  </InputAdornment>
                }
              />
            </Box>
          </Box>
          {errors?.reImbursementAmount &&
            touched?.reImbursementAmount &&
            data?.reImbursementStatus?.toLowerCase() == "draft" && (
              <Typography
                sx={{
                  width: "100%",
                  txtAlign: "center",
                }}
                color="error"
              >
                {errors?.reImbursementAmount}
              </Typography>
            )}

          {/* TODO: category dropdown */}
          <Box
            sx={{
              display:
                user == "admin" &&
                data?.reImbursementStatus?.toLowerCase() == "draft"
                  ? "flex"
                  : "none",
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
              gap: "0.25rem",
              paddingLeft: "1rem",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                color: "white",
                WebkitLineClamp: 1,
                width: "43%",
                fontWeight: "500",
              }}
            >
              Category*
            </Typography>
            <Autocomplete
              fullWidth
              freeSolo
              readOnly={
                data?.reImbursementStatus === "Accepted" ||
                data?.reImbursementStatus === "Rejected" ||
                (user !== "admin" && data?.reImbursementStatus !== "Pending") ||
                user === "contractor"
              }
              options={
                reimbursementCategories?.filter(
                  (item) => item?.reImbursementCategoryType,
                ) || []
              }
              getOptionLabel={(option) => option?.reImbursementCategoryType}
              value={{
                reImbursementCategoryType: values?.categoryType || "",
              }}
              onInputChange={(_, newVal, reason) => {
                if (reason === "input") {
                  formik.setFieldValue("categoryType", newVal);
                }
              }}
              onChange={(_, newVal) => {
                formik.setFieldValue(
                  "categoryType",
                  newVal?.reImbursementCategoryType,
                );
              }}
              componentsProps={{
                paper: {
                  style: {
                    display: "block",
                    background: "black",
                    outline: "1px solid white",
                    borderRadius: "8px",
                  },
                },
              }}
              noOptionsText={"No Categories Available"}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="categoryType"
                  placeholder="Type Here"
                  onBlur={handleBlur}
                  InputLabelProps={{
                    style: { color: "white" },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      paddingY: "7px !important",
                      "& fieldset": {
                        borderRadius: "8px",
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      },
                      "&:hover fieldset": {
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      },
                      color: "white",
                    },
                    "& .MuiInputBase-input": {
                      color: "white",
                    },
                    "& .MuiAutocomplete-popupIndicator": {
                      color: "white",
                    },
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li
                  {...props}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {option.reImbursementCategoryType}
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(
                        alertDialogAciton({
                          open: true,
                          title: "Delete Category",
                          message:
                            "Are you sure you want to delete this category?",
                          onOk: () => {
                            dispatch(
                              removeReimbursementAndDeductionCategoriesAction({
                                payload: {
                                  params: {
                                    id: option?._id,
                                  },
                                },
                                successCallback: () => {
                                  dispatch(
                                    getReimbursementCategoriesAction({}),
                                  );
                                  dispatch(
                                    alertDialogAciton({
                                      open: true,
                                      title: "Success",
                                      message: "Category Deleted Successfully.",
                                    }),
                                  );
                                },
                                failureCallback: () => {
                                  dispatch(
                                    alertDialogAciton({
                                      open: true,
                                      title: "Error",
                                      message: "Failed to delete category.",
                                    }),
                                  );
                                },
                              }),
                            );
                          },
                          okLabel: "Delete",
                        }),
                      );
                    }}
                  >
                    <Delete sx={{ color: "white", fontSize: "1.5rem" }} />
                  </IconButton>
                </li>
              )}
            />
            {touched.categoryType && errors.categoryType && (
              <Typography color={"error"} fontSize={"0.75rem"}>
                {errors.categoryType}
              </Typography>
            )}
          </Box>

          {(data?.reImbursementStatus === "Accepted" &&
            user === "contractor") ||
          (data?.reImbursementStatus === "Pending" && user === "admin") ||
          (data?.reImbursementStatus === "draft" && user === "admin") ||
          (data?.reImbursementStatus === "Accepted" && user === "admin") ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "2rem",
                  color: "white",
                  paddingLeft: "1rem",
                  width: "100%",
                  "@media(max-width: 600px)": {
                    flexDirection: "column",
                    gap: "0.5rem",
                  },
                }}
              >
                <InputLabel
                  sx={{
                    color: "white",
                    fontWeight: "500",
                    fontSize: "1rem",
                  }}
                  id="ap-amount-input"
                >
                  <Typography
                    sx={{
                      fontWeight: "500",
                      fontSize: "1rem",
                      color: "white",
                      "&:hover": {
                        cursor: "pointer",
                      },
                    }}
                  >
                    Approved Amount*
                  </Typography>
                </InputLabel>

                <Box
                  sx={{
                    position: "relative",
                  }}
                >
                  <CustomInput
                    labelId="ap-amount-input"
                    className="rate-input"
                    name="approvedAmount"
                    sx={{
                      border: `1px solid ${getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      })} `,
                      borderRadius: "8px",
                      fontSize: "16px",
                      width: "200px !important",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: `${getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        })} !important`,
                      },
                    }}
                    type="text"
                    fullWidth
                    placeholder="00.00"
                    readOnly={
                      data?.reImbursementStatus === "Accepted" ||
                      data?.reImbursementStatus === "Rejected" ||
                      (user !== "admin" &&
                        data?.reImbursementStatus !== "Pending") ||
                      user === "contractor"
                    }
                    value={approved}
                    onBlur={() => {
                      setApprovError((prev) => ({ ...prev, touched: true }));
                    }}
                    onChange={(e) => {
                      setApprovError({
                        status: false,
                        touched: true,
                        message: "",
                      });
                      setApproved(e.target.value);
                    }}
                    startAdornment={
                      <InputAdornment position="start">
                        <Typography variant="h5" color="primary">
                          &#36;
                        </Typography>
                      </InputAdornment>
                    }
                  />
                </Box>
              </Box>
              {approvError.status && (
                <Typography
                  sx={{
                    width: "100%",
                    textAlign: "center",
                  }}
                  color="error"
                >
                  {approvError.message}
                </Typography>
              )}
            </>
          ) : null}

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "0.5rem",
              color: "white",
              paddingLeft: "1rem",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <InputLabel
              sx={{
                color: "white",
                fontWeight: "500",
                fontSize: "1rem",
              }}
              id="notes-input"
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                Notes
              </Typography>
            </InputLabel>
            <TextField
              name="notes"
              multiline
              maxRows={2}
              // rows={2}
              sx={{
                width: "100%",
                border: `1px solid ${getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                })}`,
                borderRadius: "8px",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })} !important`,
                },
                "& input, fieldset, textarea": {
                  color: "white",
                  fontSize: "16px",
                },
              }}
              onChange={handleChange}
              InputProps={{
                readOnly: !isEditable,
              }}
              onBlur={handleBlur}
              value={values?.notes}
              placeholder="Add notes here"
              helperText="For per diem, record city, daily rate × days and travel days at 50%. Notes appear in the technician’s expense breakdown on newly generated POs, not in the client invoice."
              FormHelperTextProps={{ sx: { color: '#ddd' } }}
            />
          </Box>
          {errors?.notes && touched?.notes && (
            <Typography
              sx={{
                width: "100%",
                textAlign: "center",
              }}
              color="error"
            >
              {errors?.notes}
            </Typography>
          )}

          {/* images list */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "0.5rem",
              color: "white",
              paddingLeft: "1rem",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "2rem",
                color: "white",
                width: "100%",
              }}
            >
              {((isEditable && !hasSavedReimbursement) || imageList?.length > 0) && (
                <>
                  <InputLabel
                    sx={{
                      color: "white",
                      fontWeight: "500",
                      fontSize: "1rem",
                    }}
                    id="notes-input"
                  >
                    <Typography
                      sx={{
                        fontWeight: "500",
                        fontSize: "1rem",
                        color: "white",
                        "&:hover": {
                          cursor: "pointer",
                        },
                      }}
                    >
                      {hasSavedReimbursement ? "Existing images" : "Receipt files"}{values?.reImbursementType === "Parking" ? "*" : ""}
                    </Typography>
                  </InputLabel>

                  {isEditable && !hasSavedReimbursement && (
                    <Tooltip title="Add receipt (PDF, JPEG or PNG)" arrow placement="right">
                      <IconButton
                        sx={{
                          backgroundColor: getCssVariableHandler({
                            variableName: "--primary-pink-hex",
                          }),
                          "&:hover": {
                            opacity: 0.8,
                            backgroundColor: getCssVariableHandler({
                              variableName: "--primary-pink-hex",
                            }),
                          },
                        }}
                        onClick={() => {
                          imageRef.current.click();
                        }}
                      >
                        <AddPhotoAlternate
                          sx={{ color: "white", fontSize: "24px" }}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                </>
              )}
              <input
                type="file"
                accept="application/pdf,image/jpeg,image/png"
                disabled={hasSavedReimbursement || !isEditable}
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file && !["application/pdf", "image/jpeg", "image/png"].includes(file.type) && !(file.type === "" && /\.(pdf|jpe?g|png)$/i.test(file.name))) {
                    formik.setFieldTouched("files", true, false);
                    formik.setFieldError("files", "Choose a PDF, JPEG or PNG receipt");
                    return;
                  }
                  if (file?.size > RECEIPT_MAX_BYTES) {
                    formik.setFieldTouched("files", true, false);
                    formik.setFieldError("files", "Receipt must be 4 MB or smaller");
                    return;
                  }
                  if (isPdfReceipt(file)) { addImageToList(file); e.target.value = ""; return; }
                  if (!file) {
                    return;
                  } else {
                    // const fileUrl = URL.createObjectURL(file);
                    // setTempImage(fileUrl);
                    setTempImage((tempImage) => {
                      return {
                        ...tempImage,
                        objectUrl: receiptUrl(file),
                        blob: file,
                      };
                    });
                  }
                  setCropModal(true);
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                ref={imageRef}
              />
              {/* NOTE: show a button to add image */}
            </Box>
            <Box
              sx={{
                display: imageList?.length == 0 ? "none" : "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "1rem",
                color: "white",
                width: "100%",
                flexWrap: "wrap",
              }}
            >
              {/* NOTE: show  the list of all images */}
              {imageList?.map((item, index) => (
                <div
                  style={{
                    position: "relative",
                  }}
                  key={index}
                >
                  {isPdfReceipt(item?.blob) ? <Box sx={{ width: 130, p: 1, border: "1px solid #D175B6", borderRadius: 1 }}>
                    <Typography variant="body2">PDF receipt</Typography><Typography variant="caption" sx={{ overflowWrap: "anywhere" }}>{item.fileName}</Typography>
                  </Box> : <img
                    src={item?.image}
                    alt="bill"
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "8px",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setViewProfileImageFullscreen({
                        status: true,
                        image: item?.image,
                      })
                    }
                  />}
                  {isEditable && !hasSavedReimbursement && (
                    <IconButton
                      sx={{
                        position: "absolute",
                        top: "-10px",
                        right: "-10px",
                        backgroundColor: "white",
                        borderRadius: "50%",
                        padding: "0.2rem",
                        "&:hover": {
                          backgroundColor: "white",
                          opacity: 0.8,
                        },
                      }}
                      onClick={() => {
                        if (receiptObjectUrls.current.delete(item?.image)) URL.revokeObjectURL(item.image);
                        setImageList((il) => {
                          return il.filter((_, i) => i !== index);
                        });
                        formik.setFieldValue(
                          "files",
                          formik.values.files.filter((_, i) => i !== index),
                        );
                      }}
                    >
                      <Close sx={{ fontSize: "10px" }} />
                    </IconButton>
                  )}
                </div>
              ))}
            </Box>
            {errors?.files && touched?.files && (
              <Typography
                sx={{
                  width: "100%",
                  textAlign: "center",
                }}
                color="error"
              >
                {errors?.files}
              </Typography>
            )}
          </Box>

          {privateReceipts}

          {user === "contractor" &&
            isEditable &&
            (values.reImbursementType === "Equipment" ||
              values.reImbursementType === "Other") && (
              <Typography
                sx={{
                  width: "100%",
                  textAlign: "center",
                  fontSize: "1rem !important",
                }}
              >
                Note*: Attach a receipt if available, for quick processing
              </Typography>
            )}

          {user === "admin" ? (
            <>
              {/* TODO: category dropdown */}
              <Box
                sx={{
                  display:
                    data?.reImbursementStatus?.toLowerCase() == "draft"
                      ? "none"
                      : "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  gap: "0.25rem",
                  paddingLeft: "1rem",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    WebkitLineClamp: 1,
                    width: "43%",
                    fontWeight: "500",
                  }}
                >
                  Category
                </Typography>
                <Autocomplete
                  fullWidth
                  freeSolo
                  readOnly={
                    data?.reImbursementStatus === "Accepted" ||
                    data?.reImbursementStatus === "Rejected" ||
                    (user !== "admin" &&
                      data?.reImbursementStatus !== "Pending") ||
                    user === "contractor"
                  }
                  options={
                    reimbursementCategories?.filter(
                      (item) => item?.reImbursementCategoryType,
                    ) || []
                  }
                  getOptionLabel={(option) => option?.reImbursementCategoryType}
                  value={{
                    reImbursementCategoryType: values?.categoryType || "",
                  }}
                  onInputChange={(_, newVal, reason) => {
                    if (reason === "input") {
                      formik.setFieldValue("categoryType", newVal);
                    }
                  }}
                  onChange={(_, newVal) => {
                    formik.setFieldValue(
                      "categoryType",
                      newVal?.reImbursementCategoryType,
                    );
                  }}
                  componentsProps={{
                    paper: {
                      style: {
                        display: "block",
                        background: "black",
                        outline: "1px solid white",
                        borderRadius: "8px",
                      },
                    },
                  }}
                  onBlur={handleBlur}
                  noOptionsText={"No Categories Available"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="categoryType"
                      placeholder="Type Here"
                      InputLabelProps={{
                        style: { color: "white" },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          paddingY: "7px !important",
                          "& fieldset": {
                            borderRadius: "8px",
                            borderColor: getCssVariableHandler({
                              variableName: "--primary-pink-hex",
                            }),
                          },
                          "&:hover fieldset": {
                            borderColor: getCssVariableHandler({
                              variableName: "--primary-pink-hex",
                            }),
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: getCssVariableHandler({
                              variableName: "--primary-pink-hex",
                            }),
                          },
                          color: "white",
                        },
                        "& .MuiInputBase-input": {
                          color: "white",
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          color: "white",
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {option.reImbursementCategoryType}
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          dispatch(
                            alertDialogAciton({
                              open: true,
                              title: "Delete Category",
                              message:
                                "Are you sure you want to delete this category?",
                              onOk: () => {
                                dispatch(
                                  removeReimbursementAndDeductionCategoriesAction(
                                    {
                                      payload: {
                                        params: {
                                          id: option?._id,
                                        },
                                      },
                                      successCallback: () => {
                                        dispatch(
                                          getReimbursementCategoriesAction({}),
                                        );
                                        dispatch(
                                          alertDialogAciton({
                                            open: true,
                                            title: "Success",
                                            message:
                                              "Category Deleted Successfully.",
                                          }),
                                        );
                                      },
                                      failureCallback: () => {
                                        dispatch(
                                          alertDialogAciton({
                                            open: true,
                                            title: "Error",
                                            message:
                                              "Failed to delete category.",
                                          }),
                                        );
                                      },
                                    },
                                  ),
                                );
                              },
                              okLabel: "Delete",
                            }),
                          );
                        }}
                      >
                        <Delete sx={{ color: "white", fontSize: "1.5rem" }} />
                      </IconButton>
                    </li>
                  )}
                />
                {touched.categoryType && errors.categoryType && (
                  <Typography color={"error"} fontSize={"0.75rem"}>
                    {errors.categoryType}
                  </Typography>
                )}
              </Box>

              {/* TODO: should add this to invoice */}
              {data?.reImbursementStatus?.toLowerCase() ===
              "rejected" ? null : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "1rem",
                    paddingX: "1rem",
                  }}
                >
                  <Checkbox
                    checked={values?.reImburseAddInClientInvoice}
                    readOnly={
                      data?.reImbursementStatus === "Accepted" ||
                      data?.reImbursementStatus === "Rejected" ||
                      (user !== "admin" &&
                        data?.reImbursementStatus !== "Pending") ||
                      user === "contractor"
                    }
                    onChange={(e) => {
                      if (
                        data?.reImbursementStatus === "Accepted" ||
                        data?.reImbursementStatus === "Rejected" ||
                        (user !== "admin" &&
                          data?.reImbursementStatus !== "Pending") ||
                        user === "contractor"
                      )
                        return;
                      formik.setFieldValue(
                        "reImburseAddInClientInvoice",
                        e.target?.checked,
                      );
                    }}
                    sx={{
                      padding: "0 !important",
                      color: "white",
                    }}
                  />
                  <Typography>Add this in client invoice</Typography>
                </Box>
              )}
            </>
          ) : null}

          {user === "admin" && isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN) && (
            <FormControlLabel sx={{ px: 2 }} label="Add to PO / reimburse technician"
              control={<Checkbox checked={values.reImburseAddInPO} disabled={hasSavedReimbursement || !isEditable}
                onChange={e => formik.setFieldValue("reImburseAddInPO", e.target.checked)} />} />
          )}

          {data?.reImbursementStatus == "draft" && user == "admin" ? (
            data?.positionDetails?._id && data?.contractorDetails?._id ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    // gap: "1rem",
                    paddingX: 2,
                  }}
                >
                  <Typography sx={{ fontWeight: "500" }}>
                    Reimbursement Linked To
                  </Typography>
                  <FormControl
                    sx={{
                      width: "100%",
                    }}
                  >
                    <RadioGroup
                      name="isLinkToContractor"
                      row
                      sx={{ flexWrap: "wrap" }}
                      onChange={(e) => {
                        const value = e?.target?.value;
                        if (value == 0) {
                          formik?.setFieldValue("isLinkToContractor", true);
                        } else {
                          formik?.setFieldValue("isLinkToContractor", false);
                        }
                      }} // your handler
                      value={values?.isLinkToContractor ? 0 : 1}
                    >
                      <FormControlLabel
                        value="0"
                        control={
                          <Radio
                            sx={{
                              color: getCssVariableHandler({
                                variableName: "--primary-pink-hex",
                              }),
                              "&.Mui-checked": {
                                color: getCssVariableHandler({
                                  variableName: "--primary-pink-hex",
                                }),
                              },
                            }}
                          />
                        }
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.3rem",
                            }}
                          >
                            Contractor
                            {/* NOTE: update the info icon with black i and white bg */}
                            <InfoHover
                              title=" This reimbursement is linked directly to the contractor. "
                              infoStyles={{
                                color: getCssVariableHandler({
                                  variableName: "--white-rgb",
                                }),
                              }}
                              isBgFilled
                            />
                          </Box>
                        }
                      />
                      <FormControlLabel
                        value="1"
                        control={
                          <Radio
                            sx={{
                              color: getCssVariableHandler({
                                variableName: "--primary-pink-hex",
                              }),
                              "&.Mui-checked": {
                                color: getCssVariableHandler({
                                  variableName: "--primary-pink-hex",
                                }),
                              },
                            }}
                          />
                        }
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.3rem",
                            }}
                          >
                            Position
                            <InfoHover
                              title=" This reimbursement is linked to a position. If the contractor assigned to this position changes, the reimbursement will automatically transfer to the new contractor. "
                              infoStyles={{
                                color: getCssVariableHandler({
                                  variableName: "--white-rgb",
                                }),
                              }}
                              isBgFilled
                            />
                          </Box>
                        }
                      />
                    </RadioGroup>
                  </FormControl>

                  {errors?.isLinkToContractor &&
                    touched?.isLinkToContractor && (
                      <Typography
                        sx={{
                          width: "100%",
                          textAlign: "center",
                        }}
                        color="error"
                      >
                        {errors?.isLinkToContractor}
                      </Typography>
                    )}
                </Box>
              </>
            ) : null
          ) : null}

          {data?.reImbursementStatus !== "draft" ||
          (data?.reImbursementStatus == "draft" && !isBothPosAndConPresent) ? (
            ((data?.positionId || data?.positionDetails?._id) &&
              data?.reImbursementStatus == "draft") ||
            (data?.reImbursementStatus !== "draft" &&
              data?.isReimbursementAttachedToPosition) ? (
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1rem !important",
                  fontWeight: "300",
                  width: "100%",
                  color: getCssVariableHandler({
                    variableName: "--primary-green-text-hex",
                  }),
                }}
              >
                This reimbursement is linked to a position. If the contractor
                assigned to this position changes, the reimbursement will
                automatically transfer to the new contractor.
              </Typography>
            ) : (
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1rem !important",
                  fontWeight: "300",
                  width: "100%",
                  color: getCssVariableHandler({
                    variableName: "--primary-green-text-hex",
                  }),
                }}
              >
                This reimbursement is linked directly to the contractor.
              </Typography>
            )
          ) : null}

          {data?.rejectReason && (
            <Box
              sx={{
                width: "100%",
                paddingLeft: "1rem",
              }}
            >
              <Typography
                sx={{
                  fontSize: "1rem",
                  textAlign: "center",
                  border: "1px solid red",
                  borderRadius: "8px",
                  py: "0.5rem",
                }}
              >
                Reason for rejection
                <Typography
                  sx={{
                    color: "red",
                  }}
                >
                  {data?.rejectReason}
                </Typography>
              </Typography>
            </Box>
          )}

          {/* NOTE: buttons for request reimbursement */}
          <Box
            className="bottomButton"
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "2rem",
              width: "100%",
              gap: "3rem",
              "@media(max-width: 600px)": {
                flexDirection: "column",
                gap: "0.5rem",
              },
            }}
          >
            {user === "contractor" && isEditable && (
              <Button
                className="btnPink"
                sx={{
                  width: "auto !important",
                }}
                onClick={() => {
                  submitForm();
                }}
              >
                <Typography
                  sx={{
                    textWrap: "nowrap",
                  }}
                  classname="btn-text"
                >
                  Request Reimbursement
                </Typography>
              </Button>
            )}
            {user === "admin" &&
              data?.reImbursementStatus?.toLowerCase() === "pending" && (
                <>
                  {/* NOTE: for client accept and reject show a differnet button name and do a differnet thing, or show a differnet button conditionally  */}
                  <Button
                    className="btnPink"
                    sx={{
                      backgroundColor: `${theme.palette.green.main} !important`,
                    }}
                    onClick={handleAdminAccept}
                  >
                    <Typography classname="btn-text">Accept</Typography>
                  </Button>

                  <Button
                    className="btnPink"
                    sx={{
                      backgroundColor: `${getCssVariableHandler({
                        variableName: "--red-shade-1rgb",
                      })} !important`,
                    }}
                    onClick={() => {
                      setReasonModal(true);
                    }}
                  >
                    <Typography classname="btn-text">Reject</Typography>
                  </Button>
                </>
              )}
            {user == "admin" &&
              data?.reImbursementStatus?.toLowerCase() == "draft" && (
                <Button className="btnPink" onClick={submitForm}>
                  {arLoading ? (
                    <CircularProgress />
                  ) : (
                    <Typography className="btn-text">
                      Add Reimbursement
                    </Typography>
                  )}
                </Button>
              )}
          </Box>
        </AccordionDetails>
      </Accordion>

      {/* NOTE: view image on full screen */}
      <Modal
        open={viewProfileImageFullscreen?.status}
        onClose={() => {
          setViewProfileImageFullscreen({ status: false, image: null });
        }}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            maxWidth: "800px",
            width: "80vw",
            height: "75vh",
          }}
        >
          <ReusableParentContainer
            style={{
              background: getCssVariableHandler({
                variableName: "--bg-theme-rgb",
              }),
              width: "100%",
              height: "100%",
              padding: "1rem 2rem",
              zIndex: 11,
            }}
          >
            {viewProfileImageFullscreen?.image ? (
              <img
                src={viewProfileImageFullscreen?.image}
                alt=""
                style={{
                  borderRadius: "10px",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  verticalAlign: "middle",
                }}
              />
            ) : null}
          </ReusableParentContainer>
        </Box>
      </Modal>

      <ImageCropper
        open={cropModal}
        image={tempImage}
        onComplete={(image) => {
          setCropModal(false);
          addImageToList(image);
          setTempImage(null);
        }}
        containerStyle={{
          position: "relative",
          width: "100",
          height: 300,
          background: "#333",
          zIndex: 13,
        }}
        onClose={() => {
          setCropModal(false);
          setTempImage(null);
        }}
      />

      <ReasonModal
        open={reasonModal}
        handleClose={() => {
          setReasonModal(false);
          setReason("");
        }}
        reasonValue={reason}
        handleChange={(e) => {
          setReason(e.target.value);
        }}
        handleSaveEdits={handleAdminReject}
      />

      <ApproveDialog
        open={approveDialog}
        handleClose={() => {
          setApproveDialog(false);
        }}
        submitHandler={(appAmount) => {
          handleAdminAccept(appAmount);
        }}
      />
    </>
  );
}

const ApproveDialog = ({ open, handleClose, claimedAmount, submitHandler }) => {
  const [approvedAmount, setApprovedAmount] = React.useState(claimedAmount);

  React.useEffect(() => {
    setApprovedAmount(claimedAmount);
  }, [claimedAmount]);

  const style = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: 24,
    padding: 1,
    backgroundColor: "#000",
    zIndiex: 20,
    borderRadius: "16px",
    border: "2px solid #D175B6",
    width: "33%",
    maxHeight: "90vh",
    overflowY: "auto",
    "@media (max-width: 1200px)": {
      width: "50%",
      minWidth: "0",
      overflowY: "auto",
    },
    "@media (max-width: 600px)": {
      width: "96%",
      minWidth: "0",
      overflowY: "auto",
    },
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="reimbursement modal"
      aria-describedby="reimbursement modal"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            padding: "1rem",
          }}
        >
          <Typography
            sx={{
              color: "white",
              fontSize: "1.5rem",
              fontWeight: "500",
            }}
          >
            Are you sure you want to approve the reimbursement?
          </Typography>
          {approvedAmount && (
            <CustomInput
              labelId="app-amount-input"
              className="rate-input"
              name="reImbursementAmount"
              sx={{
                border: `1px solid ${getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                })} `,
                borderRadius: "8px",
                fontSize: "16px",
                width: "100% !important",
                // "& fieldset": {
                //   border: "none",
                // },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })} !important`,
                },
              }}
              type="text"
              fullWidth
              placeholder="00.00"
              onChange={(e) => {
                setApprovedAmount(e.target.value);
              }}
              value={approvedAmount}
              startAdornment={
                <InputAdornment position="start">
                  <Typography variant="h5" color="primary">
                    &#36;
                  </Typography>
                </InputAdornment>
              }
            />
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "1rem",
            }}
            className="bottomButton"
          >
            <Button
              className="btnPink"
              sx={{
                backgroundColor: `${theme.palette.green.main} !important`,
              }}
              onClick={() => {
                submitHandler(approvedAmount);
              }}
            >
              <Typography classname="btn-text">Accept</Typography>
            </Button>

            <Button
              className="btnPink"
              sx={{
                backgroundColor: `${getCssVariableHandler({
                  variableName: "--red-shade-1rgb",
                })} !important`,
              }}
              onClick={() => {
                handleClose();
              }}
            >
              <Typography classname="btn-text">Cancel</Typography>
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

ReimbursementAcc.propTypes = {
  user: PropTypes.string,
  data: PropTypes.object,
  expanded: PropTypes.string,
  handleAccChange: PropTypes.func,
  eventId: PropTypes.string,
  setData: PropTypes.func,
  isEditable: PropTypes.bool,
  status: PropTypes.string,
  index: PropTypes.number,
  fetchPO: PropTypes.func,
};

ApproveDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  claimedAmount: PropTypes.string,
  submitHandler: PropTypes.func,
};
